<div class="step-page">
	<div class="step-title">
		<div class="row-wrap">
			<div class="row-left">
				<div>
					User Management
				</div>
			</div>
			<!-- <div class="row-right">
				<button *ngIf="" class="button-general" (click)="save()">Save</button>
			</div> -->
		</div>
	</div>
	<div class="step-content">
		<div class="search-line">
			<input name="search" placeholder="User Email" [(ngModel)]="searchStr" (ngModelChange)="search()">
			<i class="glyphicons glyphicons-search"></i>
			<!-- <div *ngIf="customerType!=='integrator'&&isAdmin" class="integrator">
				<button class="button-general" (click)="pickIntegrator()">Integrator</button>
			</div> -->
		</div>
		<div class="table-container">
			<app-common-datagrid
				#userTable
				[columns]="columns"
				[rows]="rows"
				[rowH]="40"
				[columnMode]="'force'"
				[selectedRows]="selectedRows"
				[selectionType]="undefined"
				[isPaging]="false"
				[totalNum]="rows.length"
			></app-common-datagrid>
		</div>
	</div>
</div>

<ng-template #userEmailTempl let-row="row" let-value="value">
	<div *ngIf="row[isNewUserCol]">
		<input type="text" name="new-user" placeholder="Enter user email" class="new-user-email" [(ngModel)]="newUser.email" (ngModelChange)="onChangeNewUserEmail()">
	</div>
	<div *ngIf="!row[isNewUserCol]">
		{{value}}
	</div>
</ng-template>
<ng-template #roleTempl let-row="row" let-column="column" let-value="value">
	<div *ngIf="!row[isNewUserCol]||newUser.email">
		<input type="radio" name="{{rows.indexOf(row)}}-role"
		[(ngModel)]="row.userRole"
		[value]="column.prop"
		(ngModelChange)="onChangeRole(row)">
	</div>
</ng-template>
<ng-template #operationsTempl let-row="row" let-column="column" let-value="value">
	<div *ngIf="row[isNewUserCol]">
		<i class="glyphicons glyphicons-plus-sign"
			title="Add a user"
			(click)="addUser()"></i>
	</div>
	<div *ngIf="!row[isNewUserCol]">
		<i class="glyphicons glyphicons-minus-sign" title="Remove the user" (click)="removeUser(row)"></i>
	</div>
</ng-template>